export default __webpack_public_path__ + "static/media/comming-soon.e1aae983.jpg";